module.exports = __webpack_public_path__ + "img/plus-sm.923aab05.svg";